module.exports = __webpack_public_path__ + "static/media/img-pessoas-sucesso.3c303c2d.svg";